import { render, staticRenderFns } from "./EngagementTaskTextCard.vue?vue&type=template&id=2fcd5abe&"
import script from "./EngagementTaskTextCard.vue?vue&type=script&lang=js&"
export * from "./EngagementTaskTextCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports